import { axios } from '@/plugins/axios'

export default class EvaluacionDisciplinaOperativaApiRepository {
  async getById(idPersonal, idEvaluacion) {
    try {
      const { data } = await axios.get(
        `/PoliciaCuadrantes/DesarrolloPolicial/personal/${idPersonal}/disciplinaOperativa/${idEvaluacion}`
      )
      return data.data[0]
    } catch (error) {
      throw new Error(`Failed to retrieve disciplinaOperativa: ${error.message}`)
    }
  }

  async create(payload) {
    try {
      const { data } = await axios.post(
        `/PoliciaCuadrantes/DesarrolloPolicial/personal/${payload.fk_idPersonalEvaluado}/disciplinaOperativa`,
        payload
      )
      return data
    } catch (error) {
      throw new Error(`Failed to create disciplinaOperativa: ${error.message}`)
    }
  }

  async update(payload) {
    try {
      const { data } = await axios.put(
        `/PoliciaCuadrantes/DesarrolloPolicial/personal/${payload.fk_idPersonalEvaluado}/disciplinaOperativa/${payload.id}`,
        payload
      )
      return data
    } catch (error) {
      throw new Error(`Failed to update disciplinaOperativa: ${error.message}`)
    }
  }

  async updateStatus(idPersonal, idEvaluacion, payload) {
    try {
      const { data } = await axios.put(
        `/PoliciaCuadrantes/DesarrolloPolicial/personal/${idPersonal}/disciplinaOperativa/${idEvaluacion}`,
        payload
      )
      return data
    } catch (error) {
      throw new Error(`Failed to update status of disciplinaOperativa: ${error.message}`)
    }
  }

  async getProcedimientos(idPersonal) {
    try {
      const { data } = await axios.get(`/PoliciaCuadrantes/EstadoFuerza/personal/${idPersonal}/procedimientoCHJ`)
      return data.data
    } catch (error) {
      throw new Error(`Failed to get procedimientos: ${error.message}`)
    }
  }
}
